<style
  scoped
  lang="less">
  .product-header {
    border: 1px solid #eee;
    height: 45px;
    line-height: 45px;
    background: #f4f4f4;
  }

  .product-header span {
    font-size: 14px;
    color: #666;
  }

  #cart-detail-entity {
    border: 1px solid #eee;
  }

  #cart-detail-entity .cover {
    height: 114px;
    width: 150px;
    padding: 7px;
  }

  #cart-detail-entity span {
    line-height: 114px;
    height: 114px;
    font-size: 14px;
  }

  .price-text {
    font-size: 18px !important;
    color: red;
  }

  .pro_name {
    color: #333;
    font-size: 14px;
    /*margin-top: 26px;*/
  }

  #promotion {
    height: 38px;
    border-left: 1px solid #eee;
    border-right: 1px solid #eee;
    cursor: pointer;
  }

  .promotion_cir {
    display: inline-block;
    margin-top: 8px;
    margin-left: 20px;
    width: 20px;
    height: 20px;
    border: 1px solid #0077db;
    border-radius: 30px;
    color: #0077db;
    margin-right: 20px;
    font-size: 20px;
    text-align: center;
    line-height: 18px;
    vertical-align: sub;
  }

  .promotion_list {
    width: 300px;
    padding: 12px;
    background-color: #fff;
    position: absolute;
    top: 88px;
    left: 700px;
    z-index: 1000000000;
    box-sizing: content-box;
    border: 1px solid #ff9400;
    height: 400px;
    overflow: auto;

    p{
      font-size:14px;
      color: #666;
      border-bottom:1px solid #eaeaea;
      height:30px;
      text-align: left;
    }
  }
  .sanjiao{
    position: absolute;
    top: 77px;
    left: 863px;
  }
  /*.promotion_list div {*/
    /*width: 270px;*/
    /*display: block;*/
    /*background-color: #fff;*/
    /*color: #666;*/
    /*font-size: 12px;*/
    /*line-height: 28px!important;*/
    /*height: 28px!important;*/
    /*margin: 10px 0;*/
    /*padding: 0 10px;*/
    /*display: inline-block;*/
    /*&.active {*/
      /*background-color: #0077db;*/
      /*color: #fff;*/
    /*}*/
    /*&.disabled {*/
      /*background-color: #aaa;*/
    /*}*/

  /*}*/

  .promotion_de{
    display: flex;
    border: 1px dashed #ddd;
    margin: 8px 0;
    position: relative;
    align-items: center;
    &.active .check_{
      background: url("../assets/checked.png");
    }
    &.disabled {
      background: #eee;
      div:nth-of-type(1) {
        background: #eee;
      }
    }

    .check_{
      position: absolute;
      right:20px;
      top: 22px;
      width:16px;
      height:16px;
      background: url("../assets/nocheck.png");
    }
    .pr_price{
      width:60px;
      height:32px;
      background: url("../assets/quanbor.png") no-repeat center;
      line-height:32px;
      color: #ff4c00;
      font-size:14px;
      text-align: left;
      padding-left:10px;
    }
    .pr_sum{
      margin-left:20px;
      display: flex;
      align-items: center;
      div {
        align-items: center;
        margin: 4px 0;
        h3{
          font-weight:normal;
          font-size:14px;
          color: #666;
          text-align: left;
        }
        p{
          font-size:14px;
          color: #999;
          border:none;
          text-align: left;
          margin-top:2px;
        }

      }
    }
  }

</style>

<template>
  <div>
    <el-row class="product-header">
      <el-col :span="6" style="text-align: center;">
        <span>商品信息</span>
      </el-col>
      <el-col :span="3" style="text-align: center;">
        <span>单价</span>
      </el-col>
      <el-col :span="3" style="text-align: center;">
        <span>数量</span>
      </el-col>
      <el-col :span="3" style="text-align: center;">
        <span>补差</span>
      </el-col>
      <el-col :span="3" style="text-align: center;">
        <span>优惠方式</span>
      </el-col>
      <el-col :span="3" style="text-align: center;">
        <span>优惠信息</span>
      </el-col>
      <el-col :span="3" style="text-align: center;">
        <span>小计</span>
      </el-col>
    </el-row>

    <div v-for="(detail,index) in details">
      <el-row id="cart-detail-entity">
        <el-col :span="6" style="display: flex;align-items: center;text-align: center;">
          <img :src="detail.product.cover | cdn-filter" class="cover"/>
          <div class="pro_name">{{detail.product.name}}</div>
        </el-col>
        <el-col :span="3" style="text-align: center;">
          <!-- 续费客户 买 非 贷记帐产品 可享受折扣 -->
          <span class="price-text" v-if="inReduceActivity(detail.product)">
            ￥<s>{{detail.product.unitPrice}}</s>
            {{detail.product.unitPrice - detail.product.discountPrice}}
          </span>
          <span class="price-text" v-else>￥{{detail.product.unitPrice}}</span>
        </el-col>
        <el-col :span="3" style="text-align: center;">
        <span>
          {{detail.amount }}
        </span>
        </el-col>
        <el-col :span="3" style="text-align: center;">
          <span class="price-text">￥{{detail.premium ? detail.premium.toFixed(2) : 0}}</span>
        </el-col>
        <el-col :span="3" style="text-align: center;">
          <div id="promotion" style="margin-top: 40px;height: 0;">
            <!--<div v-if="inReduceActivity(detail.product)"-->
                 <!--style="border-radius: 5px;height: 30px;align-items: center;display: flex;justify-content: center">-->
              <!--<el-tooltip effect="light"-->
                          <!--content="活动与优惠券不可叠加使用"-->
                          <!--placement="top-start">-->
                <!--<img src="../assets/quan.png" alt="">-->
              <!--</el-tooltip>-->
            <!--</div>-->
            <div @click="toggleVisible(index)"
                 v-bind:style="coupons.length > 0 ? 'border: 1px solid transparent' : 'border: 1px solid transparent'"
                 style="border-radius: 5px;height: 30px;align-items: center;display: flex;justify-content: center">
              <img src="../assets/quan.png" alt="">
            </div>
            <i class="sanjiao" v-show="index===showIndex"><img src="../assets/sanjiao_che.png" alt=""></i>
            <div class="promotion_list"
                 v-show="index===showIndex">
              <p v-if="coupons.length > 0">此产品有以下券可用：</p>
              <p v-else>此产品无可用券</p>
              <div v-for="(code,index) in coupons"
                   :class="[codeClass(code, detail)]"
                   class="promotion_de"
                   @click="handleChange(detail,code,detail.couponCodeId)">
                <div class="pr_price">
                  ￥{{(code.coupon.type === 0 || code.coupon.type === 3 || code.coupon.type === 4) ? code.coupon.offPrice : code.coupon.giftPrice}}
                </div>
                <div class="pr_sum">
                  <div>
                    <h3>{{code.desc}}</h3>
                    <p>{{dateFormat(code.startTime)}}-{{dateFormat(code.endTime)}}</p>
                  </div>
                </div>
                <div class="check_">

                </div>
              </div>

              <div @click="showIndex = -1"
                   style="background: #0077db;width: 100%;height: 30px;line-height: 30px;color: #fff;font-size: 14px;">确定
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="3" style="text-align: center;height: 114px;display: flex;align-items: center;justify-content: center">
          <div>{{discountInfo(detail)}}</div>
        </el-col>
        <el-col :span="3" style="height: 114px;display: flex;align-items: center;justify-content: center">
          <div style="display: flex;justify-content: center;flex-direction: column">
            <div class="price-text">￥{{detail.totalPrice ? detail.totalPrice.toFixed(2) : 0 }}</div>
            <div style="color: #666;" v-if="SaleActivity.givingPeriodStrategy.matched(detail.product.serialId)">
          (赠送服务费：{{SaleActivity.givingPeriodStrategy.calGivingMoney(detail.product.serialId)}})
          </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
  import z from '../utils'
  import {mapGetters} from 'vuex'
  import SaleActivity from '../utils/saleActivity'

  export default {
    data(){
      return {
        SaleActivity,
        showIndex: -1,
        codeId: -1,

        // coupons: []
      };
    },

    props: {
      details: Array,
      selectedCoupons: Array,
    },
    computed: {
      ...mapGetters({
        curComp: 'currentCompany'
      }),
      coupons() {
        let coupons = this.$store.state.orderPay.coupons || []
        if (!this.details || this.details.length === 0) return []
        if (this.showIndex === -1) return []
        let detail = this.details[this.showIndex]
        console.log(this.showIndex)
        console.log(detail)

        let matchedCouponCodeIds = detail.matchedCouponCodeIds || []
        console.log(coupons)

        return coupons.filter(code => matchedCouponCodeIds.includes(code.id))
      },
      curCompanyIsRenewals() {
        let isRenewals = this.curComp && this.curComp.isRenewals
        console.log('%c[OrderDetails-curCompanyIsRenewals]', 'color: #63ADD1', isRenewals)
        return isRenewals || false
      }
    },
    methods: {
      dateFormat: z.dateFormat,
      inReduceActivity: z.inReduceActivity,
      discountInfo(detail) {
        console.log(detail)
        let {couponCodes} = detail
        let str = ''
        if (!couponCodes || couponCodes.length === 0) {
          return '-'
        }
        let totalGiftPrice = 0
        let totalOffPrice = 0
        for (let i = 0; i < couponCodes.length; i++) {
          let couponCode = couponCodes[i]
          if (!couponCode || !couponCode.coupon) {
            continue
          }
          let coupon = couponCode.coupon
          let couponType = coupon.type
          // 赠券
          if (couponType === 2) {
            totalGiftPrice += coupon.giftPrice
          }

          if (couponType === 0 || couponType === 4 || couponType === 3) {
            totalOffPrice += coupon.offPrice
          }
        }
        if (totalGiftPrice > 0) {
          str += '赠送服务费' + totalGiftPrice + '元'
        }
        if (totalOffPrice > 0) {
          str += '减免金额' + totalOffPrice + '元'
        }

        return str
      },

      codeClass (code, detail) {
        // {detailId: detailId, couponCodeIds: new Set()}
        if (!code.matchFullPrice(detail)) {
          return 'disabled'
        }
        console.log(detail.id)
        if (code.isSelected) {
          if (code.cartId === detail.id) {
            return 'active'
          } else {
            return 'disabled'
          }
        }
        return 'aa'
      },
      toggleVisible(index){
        // let coupons = this.$store.state.orderPay.coupons
        // if (!this.details || this.details.length === 0) return []
        // let detail = this.details[index]
        //
        // let matchedCouponCodeIds = detail.matchedCouponCodeIds || []
        // console.log('state coupons')
        // console.log(coupons)
        // console.log('state coupons')
        //
        // this.coupons = coupons.filter(code => matchedCouponCodeIds.includes(code.id))

        console.log(this.coupons)

        if (index === this.showIndex) {
          this.showIndex = -1;
        } else {
          if (this.details[index].coupons) {
            this.showIndex = index;
          }
        }
      },
      canUseCouponCode(codeId, detail) {
        let _couponCodeIds = this.selectedCoupons.find(c => c.detailId === detail.id).couponCodeIds

        let originTotalPrice = detail.totalPrice + detail.promotionPrice
//        let totalPrice = this.detail

        let _coupon = detail.coupons.find(code => code.id === codeId).coupon
        // console.log(_coupon.fullPrice, originTotalPrice)
        if (_coupon.fullPrice > originTotalPrice) {
          return false
        }

        if (!_couponCodeIds.has(codeId)) {
          // 如果有其他产品选择了优惠券， 设置disabled 为 true
          // selectedCoupons = [{detailId: cartId, couponCodeIds: new Set()}]
          let couponArr = this.selectedCoupons.map(sc => sc.couponCodeIds).filter(set => set.has(codeId))
          if (couponArr && couponArr.length > 0) {
//          return 'disabled'
            return false
          }
        }
        return true
      },
      async handleChange(cart, code, oldCodeId){
        // 该优惠券已被（该商品或其他商品）勾选
//        let disabled = this.selectedCoupons.has(codeId)
//        console.log(`codeId=${codeId},oldCodeId=${oldCodeId},disabled=${disabled}`)

        if (!code.matchFullPrice(cart)) {
          // console.log(code)
          this.$message.warning(`单件订单产品满 ${code.coupon.fullPrice} 元可用`)
          return false
        }

        if (code.isSelected && code.cartId !== cart.id) {
          return false
        }

        let cartId = cart.id
        let detail = this.details.find(detail => detail.id === cartId)
        let disabled = false

        if (disabled) {
          return false
        }
        else {
//        debugger
          await this.$store.dispatch(
            'selectCoupon',
            {
              cartId: detail.id,
              codeIds: [code.id],
            })
          // 刷新 优惠券列表 占用样式
          this.$forceUpdate()
        }
//        this.showIndex = -1;

      }

    }
  }
</script>



// WEBPACK FOOTER //
// OrderDetails.vue?29c9e4fc